import React from 'react';
// Data
import { faqDataArray } from '../../utils/data/FaqData';
// Images
import GalleryImage1 from '../../assets/images/main/miss-dominatrixa-elite-dominatrix-nude-in-chair.webp';
import GalleryImage2 from '../../assets/images/main/miss-dominatrixa-elite-dominatrix-with-masked-slave.webp';

function FaqSectionOne() {
  return (
    <section className='grid p-2 shadow-cardShadowBold shadow-colour4/80 dark:shadow-colour4/80'>
      <div className='grid border2 border-solid bg-colour4 dark:bg-colour4 mx-auto p-0.5'>
        <div className='grid border-4 border-solid border-colour4 bg-colour1'>
          <div className='grid lg:grid-cols-[2fr_1fr] '>
            {/* FAQ Section */}
            <article className='px-6 my-8 lg:px-10 lg:py-4'>
              <section className='mb-4 lg:mb-6 text-center lg:text-left'>
                <div className='bg-colour3 dark:bg-colour3 p-1 shadow-cardShadowBold'>
                  <div className='bg-colour5 dark:bg-colour5 p-0.5'>
                    <div className='bg-colour3 dark:bg-colour3 py-2'>
                      <h4 className=' text-colour5 dark:text-colour5 font-titleFont text-3xl lg:pl-4 px-1 -mb-1'>
                        Important Questions
                      </h4>
                    </div>
                  </div>
                </div>
              </section>
              <ul className='grid gap-4'>
                {faqDataArray.map((faq, index) => (
                  <li key={index} className='mb-4'>
                    <h3 className='text-lg font-titleFont font-semibold text-colour3'>
                      {faq.question}
                    </h3>
                    <p className='text-gray-700 dark:text-colour2 text-sm'>{faq.answer}</p>
                  </li>
                ))}
              </ul>
            </article>

            {/* Image Section */}
            <section className='flex flex-col justify-center items-center gap-y-4 lg:gap-y-8 xl:gap-y-12 p-6'>
              <img
                src={GalleryImage1}
                alt='Gallery 1'
                className='w-full max-w-md rounded-lg shadow-cardShadowBold shadow-colour4/60'
              />
              <img
                src={GalleryImage2}
                alt='Gallery 2'
                className='w-full hidden lg:grid max-w-md rounded-lg shadow-cardShadowBold shadow-colour4/60'
              />
            </section>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FaqSectionOne;
